// Ürün Depoları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.warehouses';

export const inventoryWarehousesGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  // Gerçek ekranda form solda, depo listesi sağda
  mirror: true,
  title: t(`${G}.title`, 'Ürün depoları nasıl yönetilir?'),
  intro: t(`${G}.intro`, 'Bu pencerede depoları ekleyebilir, güncelleyebilir ve depo ayarlarını yönetebilirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    form: t(`${G}.regions.form`, 'Depo formu'),
    list: t(`${G}.regions.list`, 'Mevcut depolar'),
    footer: t(`${G}.regions.footer`, 'Kapat'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Temel depo kaydını oluşturun'),
      text: t(`${G}.s1.text`, 'Listeden bir depo seçili değilken form "Yeni Depo Ekle" olarak açılır. Depo adını yazın; isterseniz adres ve açıklama girin, sonra "Yeni Depo Ekle"ye basın.'),
      tips: [
        t(`${G}.s1.tip1`, 'Depo adı zorunludur; boşken kaydet düğmesi pasif kalır.'),
        t(`${G}.s1.tip2`, 'Şube alanı isteğe bağlıdır. Şube müdürüyseniz şube kendi şubeniz olarak sabittir.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. Depo tipini seçin'),
      text: t(`${G}.s2.text`, '"Depo Tipi" alanında Normal veya Akıllı (WMS) seçin. Akıllı (WMS) seçildiğinde lokasyon modeli ve rota stratejisi ayarları açılır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Lokasyon Modeli: Bölge > Peron > Raf (3 seviye) veya Bölge > Peron > Raf > Kat > Bölme (5 seviye).'),
        t(`${G}.s2.tip2`, 'Rota Stratejisi: toplama rotasının nasıl çizileceğini belirler (S-Shape + Koridor Atlama).'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s3.title`, '3. Varsayılan depoyu belirleyin'),
      text: t(`${G}.s3.text`, '"Varsayılan depo olarak ayarla" kutusunu işaretlerseniz bu depo varsayılan depo olur. Listede "Varsayılan" etiketiyle görünür.'),
      tips: [
        t(`${G}.s3.tip1`, 'Varsayılan depo kritik bir kayıt olduğu için silinemez.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Depoyu seçip düzenleyin'),
      text: t(`${G}.s4.text`, '"Mevcut Depolar" tablosunda ad, tip, şube, durum ve adres görünür. Bir depoya tıkladığınızda soldaki form o deponun bilgileriyle dolar; değiştirip "Depoyu Güncelle"ye basın. Vazgeçmek için "İptal"e basın.'),
    },
    {
      region: 'list',
      title: t(`${G}.s5.title`, '5. Depo silme'),
      text: t(`${G}.s5.text`, 'Satırdaki çöp kutusu simgesi onay penceresini açar; "Evet, Sil" ile depo kalıcı olarak silinir.'),
      tips: [
        t(`${G}.s5.tip1`, 'Varsayılan depolarda silme düğmesi pasiftir ("Varsayılan depo silinemez").'),
        t(`${G}.s5.tip2`, 'Silme işlemi geri alınamaz.'),
      ],
    },
  ],
});
